import React from "react";
import { getAmc, sendToUrl } from "../../../utilities";

const Table = ({ data, name, amcName }) => {
  //   const [sort, setSort] = useState(null);
  //   const [stateData, updateData] = useState([]);
  const KEY_TO_TITLE_MAP = {
    top_debt: {
      name: `Best Debt ${amcName}`,
      desc: `${amcName} targets to attain long-term capital appreciation by investing in the right equity securities, which can fetch good returns for its investors. In fact, most of its equity funds have been doing well in the market and has been giving consistent returns. Check out the list below to know which would suit your risk appetite.`
    },
    top_equity: {
      name: `Best Equity ${amcName}`,
      desc: `${amcName} targets to attain long-term capital appreciation by investing in the right equity securities, which can fetch good returns for its investors. In fact, most of its equity funds have been doing well in the market and has been giving consistent returns. Check out the list below to know which would suit your risk appetite.`
    },
    top_hybrid: {
      name: `Best Hybrid ${amcName}`,
      desc: `Hybrid Schemes or balanced schemes bridge the gap between equity and debt schemes. This category is characterized by a portfolio that is made up of a mix of equity stocks and bonds and will suit investors looking for debt plus returns with higher levels of risk than fixed income schemes.`
    },
    top_selling: {
      name: `Best Selling ${amcName}`,
      desc: `${amcName} AMC offers some of the best mutual fund schemes in India. Some of the top-performing mutual funds of ${amcName} given below.`
    },
    top_10_funds: { name: `Top 10 ${amcName}`, desc: "" },
    top_tax: { name: `Best Tax Saving ${amcName}`, desc: "" }
  };

  //   const sortFn = () => {
  //     if (!!sort) {
  //       sort === "asc" ? setSort("desc") : setSort("asc");
  //     } else {
  //       setSort("asc");
  //     }
  //   };

  //   useEffect(() => {
  //     if (!!sort) {
  //       if (sort === "asc") {
  //         const newData = stateData.sort((a, b) => a.asset_aum - b.asset_aum);
  //         updateData(newData);
  //       } else {
  //         const newData = stateData.sort((a, b) => b.asset_aum - a.asset_aum);
  //         updateData(newData);
  //       }
  //     } else {
  //       updateData(data);
  //     }
  //   }, [sort]);

  const routeChange = ({ url_name }) => { };

  return (
    <>
      {data && data.length > 0 ? (
        <div className="spacer_lg">
          {KEY_TO_TITLE_MAP[name].name && (
            <h2 className="heading-1-bold tableTitle">
              {KEY_TO_TITLE_MAP[name].name}
            </h2>
          )}
          {KEY_TO_TITLE_MAP[name].desc && (
            <p className="para-2 tableDesc">
              {KEY_TO_TITLE_MAP[name].desc}
            </p>
          )}

          <div
            style={{ minHeight: "0.01%", overflowX: "auto" }}
          >
            <table style={{ width: "100%", marginBottom: "16px" }} cellspacing="0px">
              <tbody>
                <tr id="table-col-name">
                  {["FUND NAME", "CATEGORY", "RISK", "3 YR RETURN", "FUND AUM (IN CR)"].map((item, id) =>
                    (<th className={`para-4 tableColName ${id === 4 ? "text-right" : "text-left"} 
                    ${id === 0 || id === 3 ? "" : "optional"}
                    ${id === 3 ? "3yr" : ""}`}> {item} </th>))}
                </tr>

                {data.map((tableRow, id) => (
                  <tr
                    key={id}
                    className="tableRow"
                    onClick={() =>
                      window.location.href =
                      `https://www.piggy.co.in/mutual-funds/direct/${tableRow["url_name"]}/`
                    }
                  >
                    <td className="para-2-bold bold tableRowHead">
                      {tableRow["name"]}
                    </td>

                    <td className="para-3 optional">
                      {tableRow["category"]}
                    </td>
                    <td className="para-3 optional">
                      {tableRow["riskometer"]}
                    </td>
                    <td className="para-3 3yr">
                      {tableRow["return_3yr"]}
                    </td>
                    <td
                      className="para-3-bold optional"
                      align="right"
                    >
                      {tableRow["asset_aum"]}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {name === "top_10_funds" ? (
            <a
              href={`/search/?q=${getAmc(amcName)}`}
              className="flex pointer para-2-bold viewAll"
            >
              View All {amcName} Funds
            </a>
          ) : null}
        </div>
      ) : null
      }
      <style jsx>{`
      .viewAll{
        color:#4dc3b6;
        justify-content:flex-end;
        text-decoration:none;
        margin-top:16px;
      }
      .tableTitle{
        text-decoration: none;
        margin: 30px 0 16px;
      }
      .tableDesc{
        margin-bottom:16px;
      }
      .tableRow:hover > .tableRowHead {
        color: #4dc3b6;
      }
      .tableRow:hover {
        cursor: pointer;
        background-color: rgb(77, 195, 182, 0.05);
      }
      @media (max-width:768px){
        .optional{
          display:none;
        }
        .3yr{
          text-align:right !important;
        }
      }
      @media (max-width:600px){
        .viewAll{
          margin:0;
        }
      }`}</style>
    </>
  );
};

export default Table;
